export const PROCESS = {
  /** 找回支付密码流程 */
  FIND_PAY_PWD: 'findPayPwd',
  /** 解绑银行卡流程 */
  UNBIND_CARD: 'unbindCard',
  /** 修改卡限额流程 */
  UPDATE_CARD_LIMIT_AMT: 'updateCardLimitAmt',
  /** 修改支付密码流程 */
  UPDATE_PAY_PWD: 'updatePayPwd',
  /** 绑卡流程 */
  BIND_CARD: 'bindCard',
  /** 开启生物认证（指纹/FaceID）流程 */
  OPEN_BIO_AUTH: 'openBioAuth',
  /** 修改免密支付限额流程 */
  NO_PWD_LIMIT_AMT: 'noPwdLimitAmt',
  /** 支付 */
  PAY: 'pay',
}
